// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"466310de","453":"d6600a5a","732":"6eef540a","977":"febf8c24"}[chunkId] + ".chunk.js";
};